<template>
  <div class="modal fade" id="notificationModal" ref="notificationModal" tabindex="-1"
    aria-labelledby="notificationModal" aria-hidden="true">
    <div
      class="modal-dialog modal-dialog-centered mobile:!w-full mobile:!right-0 mobile:!px-3 tablet:!w-[500px] !absolute tablet:!right-4 !top-0 !m-0 h-full">
      <div class="modal-content">
        <div class="modal-body !p-3 !pb-5">
          <div
            class="relative w-full mobile:h-[70px] tablet:h-[100px] rounded-lg overflow-hidden flex items-center justify-start">
            <button type="button" class="absolute top-3 right-4 w-6 h-6 z-50 focus:!outline-none focus:!shadow-none"
              data-bs-dismiss="modal" aria-label="Close">
              <font-awesome-icon icon="times" class="w-full h-full text-red-600" />
            </button>
            <div class="relative w-full h-full flex flex-col items-center justify-center">
              <img src="../../assets/images/profile-bg.png" class="w-full object-contain absolute left-0 top-0"
                alt="backgroundImage">
              <div class="relative flex justify-between items-center w-full z-10 ps-3 !pe-12">
                <h6 class="m-0 text-xl font-roboto font-semibold text-black-100">
                  Notifications
                </h6>
              </div>
            </div>
          </div>
          <div class="responsiveOreitationHeightAdjust customScrollbar overflow-y-auto" @scroll="handleScroll">
            <div :class="customClass">
              <ul v-if="grouped.latest.length" class="my-3 p-0">
                <li v-for="(n, i) in grouped.latest" :key="'recent-' + i" class="flex gap-3 items-start mb-2">
                  <img :src="n.sender_profile_image ? n.sender_profile_image : generateAvatar(n.sender_full_name)"
                    alt="" class="w-[40px] h-[40px] rounded-full object-cover" />
                  <div class="pb-2 border-b-[1px] border-[#EFEFEF]">
                    <p class="mt-0 mb-1 font-roboto text-[15px] text-[#666666]">
                      {{ n.message }}
                    </p>
                    <p class="m-0 text-[14px] flex gap-2 items-center text-[#C2C2C2]">
                      <img src="https://cdn-icons-png.flaticon.com/512/1827/1827951.png" alt="clock"
                        class="h-[14px] w-[14px] object-cover" />
                      <span>{{ $helper.getTimeAgo(n.datetime) }}</span>
                    </p>
                  </div>
                </li>
              </ul>

              <div v-if="grouped.lastMonth.length">
                <p class="font-roboto text-[12px] text-[#999999]">Last Month</p>
                <ul class="my-3 p-0">
                  <li v-for="(n, i) in grouped.lastMonth" :key="'last-' + i" class="flex gap-3 items-start mb-2">
                    <img :src="n.sender_profile_image ? n.sender_profile_image : generateAvatar(n.sender_full_name)"
                      alt="" class="w-[40px] h-[40px] rounded-full object-cover" />
                    <div class="pb-2 border-b-[1px] border-[#EFEFEF]">
                      <p class="mt-0 mb-1 font-roboto text-[15px] text-[#666666]">
                        {{ n.message }}
                      </p>
                      <p class="m-0 text-[14px] flex gap-2 items-center text-[#C2C2C2]">
                        <img src="https://cdn-icons-png.flaticon.com/512/1827/1827951.png" alt="clock"
                          class="h-[14px] w-[14px] object-cover" />
                        <span>{{ $helper.getTimeAgo(n.datetime) }}</span>
                      </p>
                    </div>
                  </li>
                </ul>
              </div>

              <div class="mt-3" v-if="!grouped.latest.length && !grouped.lastMonth.length">
                <p class="mb-0 text-center font-roboto text-[18px] text-[#666666]">
                  No Notifications to display
                </p>
              </div>

              <div v-if="loading" class="text-center p-4">
                <span>Loading...</span>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { globals } from "../../main";
export default {
  props: ["openPopup", "customClass"],
  data() {
    return {
      notifications: [],
      page: 1,
      totalPages: 1,
      loading: false
    };
  },
  computed: {
    ...mapGetters(["notificationResponse"]),
    grouped() {
      const latest = [];
      const lastMonth = [];

      this.notifications.forEach(item => {
        const date = new Date(item.datetime);

        const now = new Date();

        const isThisMonth =
          date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear();

        if (isThisMonth) {
          latest.push(item);
        } else {
          lastMonth.push(item);
        }
      });

      return { latest, lastMonth };
    }
  },

  watch: {
    notificationResponse(newVal) {
      if (newVal) {
        globals.$loader.hide();
        this.loading = false
        this.notifications.push(...newVal.body);
        this.totalPages = newVal.paging.total_pages;
        this.page++;

        this.notificationModal()
      }
    },

    openPopup(newVal) {
      this.notifications = [],
        this.page = 1,
        this.totalPages = 1,
        this.loading = false
        globals.$loader.show();
      this.getNotifications()
    },
  },

  mounted() {

  },
  methods: {
    ...mapActions(["fetchNotifications"]),

    getNotifications() {
      if (this.loading || this.page > this.totalPages) return;
      this.loading = true;
      try {
        this.fetchNotifications({
          limit: 20,
          page: this.page
        })
      } catch (err) {
        console.error(err);
      } finally {
        // this.loading = false;
      }

    },

    handleScroll(event) {
      const el = event.target;
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 10) {

        this.getNotifications();
      }
    },

    adjustModalHeightNotification() {
      const modalContent = this.$refs.notificationModal?.querySelector('.responsiveOreitationHeightAdjust');
      if (modalContent) {
        const vh = window.innerHeight;
        const vw = window.innerWidth;
        let maxHeight;
        if (vw < 768) {
          // Mobile devices
          maxHeight = vh * 0.9 - 40; // 90% of viewport height minus some padding
        } else if (vw < 1024) {
          // Tablets
          maxHeight = vh * 0.5 - 30;
        } else {
          // Desktops
          maxHeight = vh * 0.8 - 40;
        }
        modalContent.style.maxHeight = `${maxHeight}px`;
        modalContent.style.overflowY = 'auto';
      }
    },


    notificationModal() {
      const { Modal } = require('bootstrap');
      const modalEl = this.$refs.notificationModal;
      let modal = Modal.getInstance(modalEl);
      if (!modal) {
        modal = new Modal(modalEl, {
          backdrop: 'static',
          keyboard: false
        });
      }
      // Add event listeners for show/hide
      modalEl.addEventListener('show.bs.modal', () => {
        this.$nextTick(() => {
          const scrollable = modalEl.querySelector('.responsiveOreitationHeightAdjust');
          if (scrollable) scrollable.scrollTop = 0;
        });

        this.adjustModalHeightNotification();
      });
      modalEl.addEventListener('hidden.bs.modal', () => {
        window.removeEventListener('resize', this.adjustModalHeightNotification);
        window.removeEventListener('orientationchange', this.adjustModalHeightNotification);
      });


      window.addEventListener('resize', this.adjustModalHeightNotification);
      window.addEventListener('orientationchange', this.adjustModalHeightNotification);
      modal.show();
    },

    generateAvatar(name) {
      const initials = name
        .split(" ")
        .map(n => n[0])
        .join("")
        .toUpperCase();
      return `https://ui-avatars.com/api/?name=${initials}&background=random&color=fff&size=64`;
    }
  }
};
</script>